module.exports = __webpack_public_path__ + "img/EALogo1.e869dd24.svg";